/**
 * @module MaintabSearch
 * @author Created by yanghongmei1
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { JDDevice, JDImage, JDText, JDTouchableWithoutFeedback, JDModal } from '@jdreact/jdreact-core-lib';
import IMAGE_ICON from './image/index';
import { pt, sendClickDataWithJsonParam, isWeb } from '../../../../components/utiles';
import NormalSearch from './search_mianji';
import TypeSearch from './search_type';
import PriceSearch from './search_price';
import CityPicker from '../cityPicker/index';
import LastBtn from './lastbtn';
import ReactDOM from 'react-dom';

const getChooseP = (searchObj) => {
    const chooseP = (searchObj.minRentPrice || searchObj.maxRentPrice || searchObj.minTradePrice || searchObj.maxTradePrice)
    return !!chooseP
}
export default class MaintabSearch extends Component {
    static defaultProps = {
        customStyle: {},
        searchObj: {},
        fristCode: 1,
        priceObj:{},
        mainjiList: [],
        typeList: [],
        areaList: [],
        pageScrollY: 0,
        tabBarCustomStyle: {},
        pageId: '',
        webModalBoxId: 'maintabsearchModal',
        talkParams: () => {},
        showMainTabClick: () => {}
    }

    constructor(props) {
        super(props);
        this.state = {
            areaName: '区域',
            showTabIndex: -1,
            fixedTop: 0
        };
        this.adressObj = {};
        this['0_TabRefs'] = React.createRef();
        this['1_TabRefs'] = React.createRef();
        this['2_TabRefs'] = React.createRef();
        this['3_TabRefs'] = React.createRef();
        this.tabTopBar = React.createRef();
    }
    componentDidMount() {
        const { pageId} = this.props;
    }
    clickMainTabShow = (item, index) => {
        const { showTabIndex } = this.state;
        if (index === showTabIndex) {
            return;
        }
        const arrMat = ['OfficeBuilding_DistrictOption','OfficeBuilding_PriceOption','OfficeBuilding_AreaOption','OfficeBuilding_TypeOption']
        sendClickDataWithJsonParam({
            event_id: arrMat[index],
            json_param: {page_id: this.props.pageId},
            page_id: 'OfficeBuilding_Home',
        })
        this.props.showMainTabClick(true);
        this.tabTopBar.current && this.tabTopBar.current.measure((fx, fy, w, h, px, py) => {
            setTimeout(() => {
                this.setState({
                    showTabIndex: index,
                    fixedTop: h + py - 1 // 解决安卓手机1像素的间隙问题
                });
            }, 200);
        });
    }
    MianjiSearchClick = (chooseList) => { // 多选返回tabindex 和 已选择的list,为空时返回一个id为空的list
        const { searchObj } = this.props;
        const paramsName = 'roomAreaIds';
        if (chooseList && chooseList.length > 0) {
            let ids = '';
            if (chooseList.length > 0) {
                for (let j = 0; j < chooseList.length; j++) {
                    ids = ids === '' ? chooseList[j].id + '' : (ids + ',' + chooseList[j].id);
                }
            }
            if (searchObj[paramsName] !== ids) {
                let obj = {};
                obj[paramsName] = ids;
                this.goSearchBigList(obj);
                sendClickDataWithJsonParam({
                    event_id: 'OfficeBuilding_AreaOption_Confirm',
                    page_id: 'OfficeBuilding_Home',
                    json_param: {page_id: this.props.pageId, ...obj}
                })
            }
        } else {
            if (searchObj[paramsName]) {
                this.goSearchBigList({roomAreaIds:''});
                sendClickDataWithJsonParam({
                    event_id: 'OfficeBuilding_AreaOption_Confirm',
                    page_id: 'OfficeBuilding_Home',
                    json_param: {roomAreaIds:'', page_id: this.props.pageId}
                })
            }
        }
    }
    TypeSearchClick = (obj) => { 
        sendClickDataWithJsonParam({
            event_id: 'OfficeBuilding_TypeOption_Confirm',
            page_id: 'OfficeBuilding_Home',
            json_param: {page_id: this.props.pageId, ...obj}
        })
        this.goSearchBigList(obj);
    }
    PriceSearchClick = (obj) => { 
        const matObj = {
            minRentPrice: obj.minRentPrice || '',
            maxRentPrice: obj.maxRentPrice || '',
            minTradePrice: obj.minTradePrice || '',
            maxTradePrice: obj.maxTradePrice || '',
            page_id: this.props.pageId
        }
        sendClickDataWithJsonParam({
            event_id: 'OfficeBuilding_PriceOption_Confirm',
            page_id: 'OfficeBuilding_Home',
            json_param: matObj
        })
        this.goSearchBigList(obj);
    }
    getTabAdressText = (adressObj) => {
            const lastName = adressObj.countyName ? adressObj.countyName : (adressObj.cityName ? adressObj.cityName : adressObj.provinceName);
            return adressObj.provinceId > 0 ? lastName : '区域';

    }
    adressChooseClick = (adressObj) => {
        const matObj = {
            countyId: adressObj.countyId || '',
            nearId: adressObj.nearId || '',
            streetIds: adressObj.streetIds || '',
            page_id: this.props.pageId
        }
        sendClickDataWithJsonParam({
            event_id: 'OfficeBuilding_DistrictOption_Confirm',
            page_id: 'OfficeBuilding_Home',
            json_param: matObj
        })
        this.goSearchBigList(adressObj);
    }

    _closeAndGoSearch = () => {
        const { showTabIndex } = this.state;
        this[showTabIndex + '_TabRefs'] && this[showTabIndex + '_TabRefs'].current && this[showTabIndex + '_TabRefs'].current._AllOkClick && this[showTabIndex + '_TabRefs'].current._AllOkClick();
        setTimeout(() => {
            this.setState({
                showTabIndex: -1
            });
            this.props.showMainTabClick(false);
        }, 100);
    }
    _tabResetClick = () => {
        const { showTabIndex } = this.state;
        this[showTabIndex + '_TabRefs'] && this[showTabIndex + '_TabRefs'].current && this[showTabIndex + '_TabRefs'].current._resetClick && this[showTabIndex + '_TabRefs'].current._resetClick();
    }
    goSearchBigList = (obj) => {
        this.props.talkParams(Object.assign({},this.props.searchObj, obj), true);
    }

    render() {
        const { 
            searchObj,
            customStyle,
            pageId,
            webModalBoxId,
            pageScrollY,
            tabBarCustomStyle,
            mainjiList,
            areaList,
            typeList,
            NearList,
            priceObj,
            showNear
         } = this.props;
        const { showTabIndex, areaName, fixedTop } = this.state;
        return (
            <View style={[st.container, customStyle]}>
                <View style={[st.tab_container, tabBarCustomStyle]} ref={this.tabTopBar}>
                    <JDTouchableWithoutFeedback
                        onPress={() => this.clickMainTabShow('quyu', 0)}>
                        <View style={st.tab_itemBox} >
                            <JDText
                                style={[st.tab_itemText, (showTabIndex === 0 || (searchObj.countyId || searchObj.nearId)) && st.tab_itemTextChoosed]}
                            >
                                {(areaName && areaName.length > 6) ? areaName.slice(0, 6) + '...' : areaName}
                            </JDText>
                            <JDImage style={st.tab_itemicon} source={showTabIndex === 0 ? IMAGE_ICON.up_sort : IMAGE_ICON.normal_sort} resizeMode='contain' />
                        </View>
                    </JDTouchableWithoutFeedback>
                    <JDTouchableWithoutFeedback
                        onPress={() => this.clickMainTabShow('jiage', 1)}>
                        <View style={st.tab_itemBox} >
                            <JDText
                                style={[st.tab_itemText, (showTabIndex === 1 || getChooseP(searchObj)) && st.tab_itemTextChoosed]}
                            >{'价格'}</JDText>
                            <JDImage style={st.tab_itemicon} source={showTabIndex === 1 ? IMAGE_ICON.up_sort : IMAGE_ICON.normal_sort} resizeMode='contain' />
                        </View>
                    </JDTouchableWithoutFeedback>
                    <JDTouchableWithoutFeedback
                        onPress={() => this.clickMainTabShow('mianji', 2)}>
                        <View style={st.tab_itemBox} >
                            <JDText
                                style={[st.tab_itemText, (showTabIndex === 2 || searchObj.roomAreaIds) && st.tab_itemTextChoosed]}
                            >面积</JDText>
                            <JDImage style={st.tab_itemicon} source={showTabIndex === 2 ? IMAGE_ICON.up_sort : IMAGE_ICON.normal_sort} resizeMode='contain' />
                        </View>
                    </JDTouchableWithoutFeedback>
                    <JDTouchableWithoutFeedback
                        onPress={() => this.clickMainTabShow('leixing',3)}>
                        <View style={st.tab_itemBox} >
                            <JDText
                                style={[st.tab_itemText, (showTabIndex === 3 || searchObj.houseType) && st.tab_itemTextChoosed]}
                            >类型</JDText>
                            <JDImage style={st.tab_itemicon} source={showTabIndex === 3 ? IMAGE_ICON.up_sort : IMAGE_ICON.normal_sort} resizeMode='contain' />
                        </View>
                    </JDTouchableWithoutFeedback>
                </View>
                { isWeb ? (document.getElementById(webModalBoxId) ? (ReactDOM.createPortal(
                    <JDModal visible={showTabIndex > -1} transparent={true}>
                    <JDTouchableWithoutFeedback contentContainerStyle={st.overlay} onPress={this._closeAndGoSearch}>
                    <View style={[st.childBox,{ top: pageScrollY > 20 ? pageScrollY : fixedTop }]}>
                        {
                            <View style={st.groupContainer}>
                                <JDTouchableWithoutFeedback contentContainerStyle={st.overlayAbsolute} onPress={this._closeAndGoSearch} />
                                {
                                    showTabIndex === 0 ? <JDTouchableWithoutFeedback contentContainerStyle={st.groupCityContainer}><View style={st.CityContainer_whi}>
                                    <CityPicker
                                        customStyle={{}}
                                        maxLevel={3}
                                        cityData={areaList}
                                        NearList={NearList}
                                        isMultiSelect={true}
                                        searchObj={searchObj}
                                        showNear={showNear}
                                        fristCode={this.props.fristCode}
                                        pageId={pageId}
                                        talkParams={this.adressChooseClick}

                                        ref={this['0_TabRefs'] }
                                    />
                                </View></JDTouchableWithoutFeedback> : null
                                }
                                {
                                    showTabIndex === 1 ? <JDTouchableWithoutFeedback contentContainerStyle={st.groupCityContainer}><View style={st.CityContainer_whi}>
                                        <PriceSearch
                                            searchObj={searchObj}
                                            pageId={pageId}
                                            title={'价格'}
                                            AllPriceList={priceObj.totalPriceList || []}
                                            RentPriceList={priceObj.unitPriceList || []}
                                            talkParams={this.PriceSearchClick}
                                            customStyle={{ width: pt(213) }}
                                            ref={this['1_TabRefs']}
                                        />
                                    </View></JDTouchableWithoutFeedback> : null
                                }
                                {
                                    showTabIndex === 2 ? <JDTouchableWithoutFeedback><View style={st.groupItemContainer}><NormalSearch
                                    pageId={pageId}
                                    title={'建筑面积'}
                                    list={mainjiList || []}
                                    pramsString={searchObj.roomAreaIds}
                                    talkParams={this.MianjiSearchClick}
                                    customStyle={{ width: pt(213) }}
                                    ref={this['2_TabRefs']  }
                                /></View></JDTouchableWithoutFeedback> : null
                                }
                                {
                                    showTabIndex === 3 ? <JDTouchableWithoutFeedback><View style={st.groupItemContainer}><TypeSearch
                                    searchObj={searchObj}
                                    pageId={pageId}
                                    title={'类型'}
                                    list={typeList||[]}
                                    talkParams={this.TypeSearchClick}
                                    customStyle={{}}
                                    ref={this['3_TabRefs']}
                                /></View></JDTouchableWithoutFeedback> : null
                                }
                                <LastBtn
                                    confirmClick={this._closeAndGoSearch}
                                    resetClick={this._tabResetClick}
                                    customStyle={{ width: pt(330) }}
                                    pageId={pageId}
                                />
                            </View>
                        }
                    </View></JDTouchableWithoutFeedback>
                </JDModal>, document.getElementById(webModalBoxId))) : null)
                    : <JDModal visible={showTabIndex > -1} transparent={true}>
                    <JDTouchableWithoutFeedback contentContainerStyle={st.overlay} onPress={this._closeAndGoSearch}>
                    <View style={[st.childBox,{ top: pageScrollY > 20 ? pageScrollY : fixedTop }]}>
                        {
                            <View style={st.groupContainer}>
                                <JDTouchableWithoutFeedback contentContainerStyle={st.overlayAbsolute} onPress={this._closeAndGoSearch} />
                                {
                                    showTabIndex === 0 ? <JDTouchableWithoutFeedback contentContainerStyle={st.groupCityContainer}><View style={st.CityContainer_whi}>
                                    <CityPicker
                                        customStyle={{}}
                                        maxLevel={3}
                                        cityData={areaList}
                                        NearList={NearList}
                                        isMultiSelect={true}
                                        searchObj={searchObj}
                                        showNear={showNear}
                                        fristCode={this.props.fristCode}
                                        pageId={pageId}
                                        talkParams={this.adressChooseClick}

                                        ref={this['0_TabRefs'] }
                                    />
                                </View></JDTouchableWithoutFeedback> : null
                                }
                                {
                                    showTabIndex === 1 ? <JDTouchableWithoutFeedback contentContainerStyle={st.groupCityContainer}><View style={st.CityContainer_whi}>
                                        <PriceSearch
                                            searchObj={searchObj}
                                            pageId={pageId}
                                            title={'价格'}
                                            AllPriceList={priceObj.totalPriceList || []}
                                            RentPriceList={priceObj.unitPriceList || []}
                                            talkParams={this.PriceSearchClick}
                                            customStyle={{ width: pt(213) }}
                                            ref={this['1_TabRefs']}
                                        />
                                    </View></JDTouchableWithoutFeedback> : null
                                }
                                {
                                    showTabIndex === 2 ? <JDTouchableWithoutFeedback><View style={st.groupItemContainer}><NormalSearch
                                    pageId={pageId}
                                    title={'建筑面积'}
                                    list={mainjiList || []}
                                    pramsString={searchObj.roomAreaIds}
                                    talkParams={this.MianjiSearchClick}
                                    customStyle={{ width: pt(213) }}
                                    ref={this['2_TabRefs']  }
                                /></View></JDTouchableWithoutFeedback> : null
                                }
                                {
                                    showTabIndex === 3 ? <JDTouchableWithoutFeedback><View style={st.groupItemContainer}><TypeSearch
                                    searchObj={searchObj}
                                    pageId={pageId}
                                    title={'类型'}
                                    list={typeList||[]}
                                    talkParams={this.TypeSearchClick}
                                    customStyle={{}}
                                    ref={this['3_TabRefs']}
                                /></View></JDTouchableWithoutFeedback> : null
                                }
                                <LastBtn
                                    confirmClick={this._closeAndGoSearch}
                                    resetClick={this._tabResetClick}
                                    customStyle={{ width: pt(330) }}
                                    pageId={pageId}
                                />
                            </View>
                        }
                    </View></JDTouchableWithoutFeedback>
                </JDModal>
                }
            </View>
        );
    }
}

MaintabSearch.propTypes = {
    pageScrollY: PropTypes.number,
    webModalBoxId: PropTypes.string,
    pageId: PropTypes.string,
    customStyle: PropTypes.object,
    tabBarCustomStyle: PropTypes.object,
    talkParams: PropTypes.func,
    showMainTabClick: PropTypes.func,
    priceObj: PropTypes.object,
    mainjiList: PropTypes.array,
    typeList: PropTypes.array,
    areaList: PropTypes.array,
    searchObj: PropTypes.object,
    fristCode: PropTypes.number,
};

const st = StyleSheet.create({
    overlay: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        zIndex: 100,
    },
    overlayAbsolute: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        flex: 1
    },
    container: {
        position: 'relative',
        width: '100%',
        backgroundColor: '#f6f6f6',
        height: pt(88)
    },
    tab_container: {
        height: pt(88),
        paddingHorizontal: pt(32),
        backgroundColor: '#f6f6f6',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    childBox: {
        position: 'absolute',
        left: 0,
        bottom: 0,
        width: JDDevice.width,
        backgroundColor: 'rgba(0,0,0,0.6)'
    },
    groupContainer: {
        position: 'relative',
        width: JDDevice.width,
        height: '100%',
        paddingBottom: pt(135)
    },
    groupDrawerContainer: {
        overflow: 'hidden',
        borderBottomLeftRadius: pt(28),
        borderBottomRightRadius: pt(28),
        backgroundColor: '#ffffff'
    },
    groupItemContainer: {
        paddingHorizontal: pt(32),
        paddingTop: pt(26),
        paddingBottom: pt(26),
        overflow: 'hidden',
        backgroundColor: '#ffffff'
    },
    groupCityContainer: {
        height: '60%',
        width: JDDevice.width
    },
    CityContainer_whi: {
        height: '100%',
        width: JDDevice.width
    },
    tab_itemBox: {
        height: pt(88),
        flexDirection: 'row',
        alignItems: 'center'
    },
    tab_itemicon: {
        width: pt(28),
        height: pt(28)
    },
    tab_itemText: {
        textAlign: 'center',
        fontSize: pt(28),
        color: '#262626'
    },
    tab_itemTextChoosed: {
        color: '#FA2C19'
    }

});
